<template>
    <div class="page">
        <navigation-bar Close/>
        <div class="main">
            <div class="coupon-top">
                <img :src="imageUrl">
                <el-row type="flex" justify="center" class="button-line">
                    <el-button type="info"
                               class="fixed-w-150 fixed-h-50"
                               @click="showModel = true"
                               round>我要兌換
                    </el-button>
                </el-row>
            </div>

            <div class="container">
                <div class="coupon-body">

                    <div>
                        <span class="coupon-type">{{convertTypeName}}</span>
                    </div>
                    <div class="name overflow-omitted">
                        {{convertName}}
                    </div>

                    <div class="UseBranch">
                        <h6>適用分店</h6>
                        <div class="branch-list" @click="gotoUsefulStoreList()">
                    <span v-for="(item, index) in storeNameList" :key="index">
                      {{item.name === "" ? item.brandName : item.brandName+"-"+item.name}}
                    </span>
                        </div>
                        <div class="arrow-btn" @click="gotoUsefulStoreList()" v-show="storeNameList.length > 0">
                            <i class="el-icon-arrow-right"/>
                        </div>
                    </div>
                </div>
                <div v-show="isShowContent(content)">
                    <h6 class="mt-3">{{contentTitle}}</h6>
                    <p>{{content}}</p>
                </div>
                <h6 class="mt-4" v-show="precautions !== ''">注意事項</h6>
                <p v-show="precautions !== ''" v-html="precautions"></p>
            </div>
        </div>
        <points-exchange-dialog :value="showModel"
                                :convertData="convertData"
                                :appendToBody="isWeb"
                                :isWeb="isWeb"
                                @result="onPointsExchangeDialogResult"/>
        <!--網頁轉贈用-->
        <CommDialog :value="isShowDialogWeb"
                    class="isWeb"
                    :appendToBody="true"
                    :isIcon="false"
                    :isCancel="false"
                    :outerContent="''"
                    :isShowClose="true"
                    @result="onCommDialogClose">
            <UsefulStoreList isWeb :dataTokenWeb="dataToken" class="web-content" v-if="isShowDialogWeb"/>
        </CommDialog>
        <loading
                :active.sync=isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
    </div>
</template>

<script>
    import PointsExchangeDialog from "./components/PointsExchangeDialog";
    import * as constDefine from "@/store/constDefine";
    import UsefulStoreList from "@/views/store/UsefulStoreList";
    import CommDialog from '@/components/CommDialog.vue';

    export default {
        name: "LoyaltyCardExchangeDetail",
        props: {
            isWeb: Boolean,
            dataTokenWeb: {default: ''},
        },
        components: {
            PointsExchangeDialog,
            UsefulStoreList,
            CommDialog,
        },
        data() {
            return {
                isLoading: false,
                showModel: false,//集點卡兌換彈框
                loyaltyCardConvertId: 0,
                exchangeMethod: 0,
                loyaltyCardListId: 0,
                imageUrl: "",
                convertName: "",
                convertTypeName: "",
                contentTitle: "",
                content: "",
                precautions: "",
                storeNameList: [],

                convertData: {
                    pointAmount: 0,
                    id: 0,
                    type: 0,                        //兌換種類
                    typeId: 0,                      //對應的id
                    costPoint: 0,                   //單次要扣除多少點數
                    costPrice: 0,                   //單次要扣除多少費用
                    convertCount: 0,                //單次兌換數量
                    convertMethod: 0,               //兌換方法
                    unit: "",                       //單位
                    exchangeMethod: 0,              //1:免費兌換、2:加價兌換
                },

                dataToken: '',
                isShowDialogWeb: false,

            }
        },
        created() {
            this.loyaltyCardConvertId = this.isWeb ? parseInt(this.dataTokenWeb.i) : parseInt(this.$route.query.i);
            this.exchangeMethod = this.isWeb ? parseInt(this.dataTokenWeb.e) : parseInt(this.$route.query.e);
        },
        mounted() {
            this.setupData()
        },
        methods: {
            setupData() {
                this.isLoading = true
                this.$http.fetchWithAuth`GetLoyaltyCardConvertInfo${{
                    'id': this.loyaltyCardConvertId,
                }}
              ${json => {
                    if (json.status) {
                        let convertInfo = json.data.convertInfo
                        this.loyaltyCardListId = convertInfo.loyaltyCardListId;
                        this.imageUrl = convertInfo.imageUrl;
                        this.convertName = convertInfo.convertName;
                        this.convertTypeName = convertInfo.loyaltyCardConvertTypeName;
                        this.contentTitle = convertInfo.contentTitle;
                        this.content = convertInfo.content;
                        this.precautions = convertInfo.precautions;
                        this.storeNameList = convertInfo.storeNameList;

                        this.convertData.pointAmount = convertInfo.amount;
                        this.convertData.id = convertInfo.loyaltyCardConvertId;
                        this.convertData.type = convertInfo.loyaltyCardConvertType;
                        this.convertData.typeId = convertInfo.loyaltyCardConvertTypeId;
                        this.convertData.convertMethod = convertInfo.convertMethod;
                        this.convertData.unit = convertInfo.unit;
                        this.convertData.exchangeMethod = this.exchangeMethod;

                        if (this.exchangeMethod === constDefine.FREE_CONVERT) {
                            this.convertData.costPoint = convertInfo.freeConvertPoint;
                            this.convertData.costPrice = 0;
                            this.convertData.convertCount = convertInfo.freeConvertCount;
                        } else if (this.exchangeMethod === constDefine.PURCHASE_CONVERT) {
                            this.convertData.costPoint = convertInfo.purchaseConvertPoint;
                            this.convertData.costPrice = convertInfo.purchaseConvertPrice;
                            this.convertData.convertCount = convertInfo.purchaseConvertCount;
                        }

                    } else {
                        this.$public.showNotify(json.message, json.status);
                    }
                    this.isLoading = false
                }}`;
            },
            gotoUsefulStoreList() {
                let type = ""
                let id = 0
                if ((this.convertData.type >= 0 && this.convertData.type <= 4) || this.convertData.type === 6) {
                    type = "coupon"
                    id = this.convertData.typeId
                } else if (this.convertData.type === 5) {
                    type = "loyaltyCard"
                    id = this.loyaltyCardListId
                }

                if (type !== "") {


                    if(!this.isWeb){
                        this.$router.push({name: 'UsefulStoreList', query: {type: type, id: id}});
                    }else {
                        //單店網頁版用
                        this.dataToken={type: type, id: id}
                        this.isShowDialogWeb = true
                    }
                }
            },
            //集點卡兌換dialog送出
            onPointsExchangeDialogResult(result) {
                this.showModel = false;
                if (result) {
                    this.setupData()
                }
            },

            /** 是否顯示活動說明 */
            isShowContent: function(content) {
                let result = this.$public.notNull(content) && (content !== '');
                return result;
            },

            onCommDialogClose() {
                this.isShowDialogWeb = false;
            },
        }
    }
</script>
<style lang="less" scoped src="../../less/gift.less"/>
